import PropTypes from 'prop-types';

export enum StorybookDocSections {
  DataDisplay = 'Data Display',
  Disclosure = 'Disclosure',
  Feedback = 'Feedback',
  Forms = 'Forms',
  GettingStarted = 'Getting Started',
  Hooks = 'Hooks',
  Layout = 'Layout',
  MediaIcons = 'Media & Icons',
  Navigation = 'Navigation',
  Others = 'Others',
  Overlay = 'Overlay',
  PageShells = 'Page Shells',
  Theming = 'Theming',
  Typography = 'Typography'
}

export type SelectLikeSizes = 'sm' | 'md' | 'lg';
export const selectLikeSizes: SelectLikeSizes[] = ['sm', 'md', 'lg'];
export const selectLikePropTypes = {
  size: PropTypes.oneOf(selectLikeSizes),
  defaultChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isFocusable: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool
};

export const selectLikeDefaultProps = {
  size: 'md'
};
